import { render, staticRenderFns } from "./ManufacturerTable.vue?vue&type=template&id=5292299f"
import script from "./ManufacturerTable.vue?vue&type=script&lang=ts"
export * from "./ManufacturerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports